import React from 'react'

import dynamic from 'next/dynamic'
import type { ApplePayButtonUIs } from '@/components/ApplePay/ApplePayButtonUI'

const Modal = dynamic(import('@csc/dls/Modal'))
const ApplePayButtonUI = dynamic(import('@/components/ApplePay/ApplePayButtonUI'))

const ApplePayNotAvailableModal: React.FC<{
  open: boolean,
  onClose: () => void,
  message: React.ReactNode
}> = ({
  open,
  onClose,
  message,
}) => (
  <Modal open={open} onClose={onClose} closeable>
    {message}
  </Modal>
)

type ApplePayExperience = 'miniCart' | 'pdp' | 'cart'

const applePayDataTestId = (key?: ApplePayExperience) => {
  if (!key) {
    return ''
  }
  const dataTestIds = {
    miniCart: 'apple-pay-mini-cart-cta',
    cart: 'apple-pay-cart-cta',
    pdp: 'apple-pay-pdp-cta',
  }
  return dataTestIds[key] ?? ''
}

const applePayMessages = (key?: ApplePayExperience) => {
  if (!key) {
    return ''
  }
  const messages = {
    miniCart: 'Check Out With',
    cart: 'Check Out With',
    pdp: 'Buy With',
  }
  return messages[key] ?? ''
}

const ApplePayCTA: React.FC<{
  applePayExperience?: ApplePayExperience,
  onStartCheckout: () => void,
  modalContent: React.ReactNode,
  onCloseModal: () => void,
  ctaRef: React.RefObject<HTMLButtonElement>,
  buttonHeightClassName?: string,
  theme?: ApplePayButtonUIs,
  paymentMethod: 'applePay' | 'link' | undefined
}> = ({
  applePayExperience,
  buttonHeightClassName,
  theme = 'white-with-line',
  onStartCheckout,
  modalContent,
  onCloseModal,
  ctaRef,
  paymentMethod,
}) => (
  <>
    <ApplePayButtonUI
      theme={theme}
      ctaRef={ctaRef}
      onClick={onStartCheckout}
      message={applePayMessages(applePayExperience)}
      buttonHeightClassName={buttonHeightClassName}
      dataTestId={applePayDataTestId(applePayExperience)}
      paymentMethod={paymentMethod}
    />
    <ApplePayNotAvailableModal
      open={!!modalContent}
      onClose={onCloseModal}
      message={modalContent}
    />
  </>
)

export default ApplePayCTA
